import { SignalRBase } from "./signalRBase";

class ApplicationHubService {
	onReceiveApplicationStatus = callback => {
		try {
			SignalRBase.connection.on("NotifyClient", data => callback(data));
		} catch {
			setTimeout(() => this.onReceiveApplicationStatus(callback), 5000);
		}
	};
}

const applicationHubService = new ApplicationHubService();
export { applicationHubService as ApplicationHubService };
